export const NOTES_PAGE_SIZE = 12
export const DEFAULT_NOTE_SUBJECT = "General"

export type NoteColor = "blue" | "emerald" | "amber" | "rose" | "purple"

export interface StudentNote {
  id: string
  title: string
  content: string
  subject: string
  color: NoteColor
  created_at: string | null
  updated_at: string | null
}

export interface NoteCardViewModel {
  id: string
  title: string
  content: string
  subject: string
  color: NoteColor
  dateLabel: string
}

export interface NoteDraft {
  title: string
  content: string
  subject: string
  color: NoteColor
}

export const EMPTY_NOTE_DRAFT: NoteDraft = {
  title: "",
  content: "",
  subject: DEFAULT_NOTE_SUBJECT,
  color: "blue",
}
